import { render } from "./SlaHeatmap.vue?vue&type=template&id=5938a05e"
import script from "./SlaHeatmap.vue?vue&type=script&lang=js"
export * from "./SlaHeatmap.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/etl/etl/outerspace-admin-2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__